import { IModel, IAttribute } from '../base/annotation';
import { Activity } from './activity';
import { ScopeJobDefinition } from '../scopejobdefinition/scopejobdefinition';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { ParameterConfig } from './parameter-config';

export enum ScopeCapacityAllocation {
    Default,
    AbsoluteNumber,
    Percentage
}

@Metamodel.model({
    name: ModelConstants.scopeJobActivity,
    referable: true
})
export class SynapseScopeJobDefinitionActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly SCRIPT_PARAMETERS: IAttribute;
    public static readonly PRIORITY: IAttribute;
    public static readonly MAX_UNAVAILABLITY: IAttribute;
    public static readonly TAGS: IAttribute;
    public static readonly NEBULA_ARGUMENTS: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.SynapseScopeJobDefinition,
        constraint: {
            required: true
        },
        reference: true
    })
    public scopeJobDefinition: ScopeJobDefinition;

    @Metamodel.attribute({
        display: shellStringResources.ScopeScriptParameters,
        association: 'SCRIPT_PARAMETERS',
        templatable: true,
        accepts: ['Array']
    })
    public scriptParameters?: ParameterConfig[] = [];

    @Metamodel.attribute({
        display: shellStringResources.Priority,
        association: 'PRIORITY',
        templatable: true
    })
    public priority?: number;

    @Metamodel.attribute({
        display: shellStringResources.MaxUnavailability,
        association: 'MAX_UNAVAILABLITY',
        templatable: true
    })
    public maxUnavailability?: number;

    public standardCapacityAllocation?: ScopeCapacityAllocation;
    public standardCustomValue?: number;
    public ecoCapacityAllocation?: ScopeCapacityAllocation;
    public ecoCustomValue?: number;

    @Metamodel.attribute({
        display: shellStringResources.ScopeCustomProperties,
        association: 'TAGS',
        templatable: true,
        accepts: ['Array']
    })
    public tags?: ParameterConfig[] = [];

    @Metamodel.attribute({
        display: shellStringResources.NebulaArguments,
        association: 'NEBULA_ARGUMENTS',
        templatable: true
    })
    public nebulaArguments?: string;
}
